export default {
    colors: {
        primary: '#FABD4B',
    },
};
